import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {wissensportalEnums} from 'ag-common/tools/wissensportal'
import NotStartedBadge from '#components/svg/icons/NotStartedBadge'
import InProgress from '#components/svg/icons/InProgress'
import CheckMarkBadge from '#components/svg/icons/CheckMarkBadge'
import ArrowLeft from '#components/svg/icons/ArrowLeft'
import Text from '#components/a/Text'

function renderStatusIcon(status) {
  switch (status) {
    case wissensportalEnums.NOT_STARTED:
      return <NotStartedBadge />
    case wissensportalEnums.IN_PROGRESS:
      return <InProgress />
    case wissensportalEnums.FINISHED:
      return <CheckMarkBadge />
    default:
      return null
  }
}
function CourseButton({handleClick, course, isVertical, disabled}) {
  const {isActive, name, status} = course
  const className = useMemo(() => {
    let base = 'courseButton'
    if (isVertical) {
      base += ' courseButton--vertical'
    }
    if (isActive) {
      base += ' courseButton--active'
    }
    return base
  }, [isActive, isVertical])
  return (
    <button
      type="button"
      onClick={() => {
        handleClick(course)
      }}
      className={className}
      disabled={disabled}
    >
      {renderStatusIcon(status)}
      <Text text={name} modifier="highlight" />
      <ArrowLeft />
      {isActive && !isVertical && <div className="triangle" />}
    </button>
  )
}

CourseButton.propTypes = {
  handleClick: PropTypes.func,
  course: PropTypes.shape({
    isActive: PropTypes.bool,
    id: PropTypes.number,
    name: PropTypes.string,
    status: PropTypes.oneOf(['NOT_STARTED', 'IN_PROGRESS', 'FINISHED']),
  }),
  isVertical: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
}

export default CourseButton
